import React, {useState} from 'react';
import classes from "./settings.module.css";
import {texts} from "../../../../translate";
import {deleteAccount, saveMe} from "../../../../utils/api";

const Settings = ({
    lang,
    setLang,
    name,
    avatar,
    setOpenSettings,
    setOpenInstruction,
    notifyRounds,
    setNotifyRounds,
    openRound,
    cryptoAddress,
}) => {
    const [busy, setBusy] = useState(false)
    const t = texts[lang].settings

    async function saveSetting(){
        await saveMe(cryptoAddress || '', false, notifyRounds)
        setOpenSettings(false)
    }

    async function removeAccount(){
        if (!window.confirm(t.deleteConfirm)) return
        setBusy(true)
        await deleteAccount()
        setBusy(false)
        setOpenSettings(false)
    }

    return (
        <div className={classes._}>
            <div className={classes.block}>
                <div className={classes.block1}>
                    {avatar ? <img alt={''} src={avatar} className={classes.avatar}/>:
                        <div className={classes.avatar2}>{(name || '?').slice(0,1)}</div>
                    }
                    <div className={classes.name}>{name}</div>
                </div>
                <div className={classes.langs}>
                    <button type="button" className={lang==='ru' ? classes.langOn : classes.lang} onClick={()=>setLang('ru')}>RU</button>
                    <button type="button" className={lang!=='ru' ? classes.langOn : classes.lang} onClick={()=>setLang('eng')}>EN</button>
                </div>
                <div className={classes.block2}>
                    <div className={classes.text}>{t.text}</div>
                    <label className={classes.workRightSwitch}>
                        <input
                            type={"checkbox"}
                            checked={ Boolean(notifyRounds) }
                            onChange={(e) => setNotifyRounds(e.target.checked)}
                        />
                        <span className={classes.workRightSlider}></span>
                    </label>
                </div>
                <p className={classes.hint}>{openRound ? t.addressRound : t.address}</p>
                <button type="button" className={classes.link} onClick={() => { setOpenSettings(false); setOpenInstruction(true) }}>{t.docs}</button>
                <a className={classes.link} href="mailto:support@alderwayne.group">{t.support}</a>
                <button type="button" className={classes.danger} disabled={busy} onClick={removeAccount}>{t.delete}</button>
            </div>
            <div className={classes.save} onClick={saveSetting}>{t.save}</div>
        </div>
    );
};

export default Settings;
